import { observer } from "mobx-react";
import React from "react";

import { Button } from "@/components/Elements";
import DashboardHeader from "@/components/shared/DashboardHeader";

function MyTasksPage() {
  return (
    <DashboardHeader
      title={"My Tasks"}
      RightActionBar={<Button label="New Task" size="sm" />}
    />
  );
}

export default observer(MyTasksPage);
